module.exports = __webpack_public_path__ + "static/media/review_bad.3261edab.png";